import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const scrollToContact = () => {
    const element = document.getElementById('contatti');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.readdy.ai/image/26c3401126eecf15eb2286ded28883ff/9b7559ebd1d86d4594422d84406aa679.png"
          alt="Meccanico mobile Metamorfosi al lavoro a domicilio del cliente"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50 md:from-black/40 md:via-black/30 md:to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center pt-20 md:pt-0">
        <div className="inline-block mb-4 md:mb-6">
          <span className="inline-block px-4 sm:px-8 py-2 sm:py-3 border-2 border-[#E31E24] text-[#E31E24] bg-white font-bold text-xs sm:text-sm tracking-wider rounded-full">
            SERVIZIO A DOMICILIO
          </span>
        </div>
        
        <h1 className="font-black text-white tracking-wide leading-tight mb-4 md:mb-6">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-8xl">METAMORFOSI</span>
          <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">PREPARAZIONI</span>
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 font-light max-w-3xl mx-auto mb-6 md:mb-10 px-2">
          Manutenzione Auto e Moto&nbsp;
        </p>
        
        <a 
          href="#contatti"
          onClick={(e) => {
            e.preventDefault();
            scrollToContact();
          }}
          className="group inline-flex items-center bg-[#E31E24] text-white font-bold text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-[#c41a1f] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          <span className="mr-3 sm:mr-4">PRENOTA ORA</span>
          <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-black flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-base sm:text-lg"></i>
          </div>
        </a>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
}